import { HttpErrorsType } from '../../application/protocols/http-client';
import { type DomainException } from './domain-exception';

export class BlockedAccountException implements DomainException {
  message = HttpErrorsType.ACCOUNT_INACTIVE;
  code = 'Error';
}
